const { pathname } = window.location;

let splittedPaths = pathname.split('/');
export const account = splittedPaths[2];
export const accountBaseUrl = `/booking/${account}`;
